import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Form } from '../models/form.model';
import { Invite } from '../models/invite.model';
import { Pagination } from '../models/pagination.model';
import { Http } from '@angular/http';


@Injectable()
export class FormService {

    constructor(
        private api: ApiService,
        protected http: Http,
    ) {
    }

    sendMail(data): Observable<any[]> {
        return this.api.post('forms/invite', data);
    }

    getFormsList(): Observable<any[]> {
        return this.api.get('forms/list');
    }

    find(token, params): Observable<Form> {
        return this.api.get('forms/' + token, params);
    }

    findByInviteToken(token: string): Observable<Invite> {
        return this.api.get('invites/' + token);
    }

    submitForm(inviteToken, params): Observable<any[]> {
        return this.api.post('forms/' + inviteToken, params);
    }

    store(token, params): Observable<any[]> {
        return this.api.post('invites/' + token, params);
    }

    getAllInvitees(params): Observable<Pagination> {
        return this.api.get('forms/get-all-invitees', params);
    }

    createRedirectedInvitee(body) {
        return this.api.post('forms/create-invitees', body);
    }

    // uploadFiles(url: string, formData: FormData) {
    //     return this.http.post(url, formData);
    // }
    
    uploadFile(url: string, formData: FormData) {
        return this.http.post(url, formData);
    }

    sendMultipleFollowUpMail(ids) {
        return this.api.post('all-invitees/send-multiple-follow-up-mail', { 'ids': ids });
    }

    sendFollowUpMail(id) {
        return this.api.post('all-invitees/send-follow-up-mail/' + id, {});
    }

    getFollowUpDetails(id) {
        return this.api.get('invitees/follow-up-details/' + id);
    }

    getDataForExcel(params) {
        return this.api.get('invitees/download', params);
    }

    toggleInviteStatus(id: number): Observable<{'success': boolean}> {
        return this.api.post('invitees/' + id + '/toggle-status', {});
    }

    getConsentForm( token: string ) {
        return this.api.get("candidate/consent/" + token);
    }

    uploadConsentForm( token: string, formData: FormData) {
        return this.api.upload('candidate/consent/' + token, formData);
    }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/core/services/form.service.ts